import { Chip, SxProps, Theme } from '@mui/material';
import {
  LabelValue,
  LabelValueWithKey,
} from '../../../interfaces/delivery-company/labels';
import { TurnedInNot } from '@mui/icons-material';
import { displayMoney } from '../../../utils/money';

export const showOrderLabel = (
  label: LabelValueWithKey | LabelValue,
  sx?: SxProps<Theme>
): JSX.Element => {
  const extraCharge = displayMoney(label.extra_delivery_fee);
  const prefix = 'key' in label ? `${label.key}:` : '';
  const displayLabel = `${prefix}${label.value} ${extraCharge == '0' ? '' : `(+${extraCharge})`}`;
  return <Chip sx={sx} icon={<TurnedInNot />} label={displayLabel} />;
};
